import React, { useState } from 'react';
import DocumentApiService from './services/documentApi';
// Store configuration removed from client code for security

function DocumentGenerator() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);
  
  const [formData, setFormData] = useState({
    orderId: '',
    documentType: 'both',
    signedBy: 'Eric Lee',
    invoiceDate: new Date().toISOString().split('T')[0],
    contractNumber: 'BVC-2025-Q1-001',
    carrier: 'Other',
    prepaid: false,
    remarks: 'Handle with care - Electronic products',
    sailingDate: '',
    // Store configuration should come from server-side
    // Never expose access tokens in client code
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const api = new DocumentApiService();
      const response = await api.generateDocument(formData);
      setResult(response);
      
      // 새 탭에서 문서 열기
      if (response.documentUrl) {
        window.open(response.documentUrl, '_blank');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div style={{ maxWidth: '600px', margin: '50px auto', padding: '20px' }}>
      <h1>BlackVue Document Generator</h1>
      
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label>
            Order ID (Required):
            <input
              type="text"
              name="orderId"
              value={formData.orderId}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Document Type:
            <select
              name="documentType"
              value={formData.documentType}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            >
              <option value="packing">Packing List Only</option>
              <option value="commercial">Commercial Invoice Only</option>
              <option value="both">Both Documents</option>
            </select>
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Signed By:
            <input
              type="text"
              name="signedBy"
              value={formData.signedBy}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Invoice Date:
            <input
              type="date"
              name="invoiceDate"
              value={formData.invoiceDate}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Contract Number:
            <input
              type="text"
              name="contractNumber"
              value={formData.contractNumber}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Carrier:
            <input
              type="text"
              name="carrier"
              value={formData.carrier}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            <input
              type="checkbox"
              name="prepaid"
              checked={formData.prepaid}
              onChange={handleChange}
            />
            Prepaid
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Sailing Date:
            <input
              type="date"
              name="sailingDate"
              value={formData.sailingDate}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label>
            Remarks:
            <textarea
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              rows="3"
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </label>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: '10px 20px',
            background: loading ? '#ccc' : '#191919',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Generating...' : 'Generate Document'}
        </button>
      </form>

      {error && (
        <div style={{ color: 'red', marginTop: '20px' }}>
          Error: {error}
        </div>
      )}

      {result && (
        <div style={{ marginTop: '20px', padding: '15px', background: '#f5f5f5', borderRadius: '5px' }}>
          <h3>Document Generated Successfully!</h3>
          <p>Document URL: <a href={result.documentUrl} target="_blank" rel="noopener noreferrer">{result.documentUrl}</a></p>
        </div>
      )}
    </div>
  );
}

export default DocumentGenerator;